export default __webpack_public_path__ + "static/media/survey-wedding.74591c85.png";